import React from 'react'
import DisplayTimeSheet from '../components/TimeSheet/DisplayTimeSheet'



export default function TimesheetEntryPage() {
  return (
    <div className="layout-body">
      <div className="row">
        <div className="col-md-12">
          <DisplayTimeSheet />
         

        </div>
      </div>

    </div>
  )
}
